/* eslint-disable linebreak-style */
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <App />
 </BrowserRouter>
);

// PDV instalável e funcionando sem internet (ver service-worker.ts e
// shared/offline). Service worker só no build de produção — em
// desenvolvimento ele atrapalharia o hot reload servindo arquivos em cache.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`).catch((erro) => {
      console.error('Falha ao registrar o service worker:', erro);
    });
  });
}

// Pede ao navegador pra não apagar o banco local por falta de espaço — é
// nele que ficam as vendas feitas offline até serem enviadas.
navigator.storage?.persist?.().catch(() => undefined);



